var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cdh-logo"},[_vm._v("\n  Centre"),_c('br'),_c('span',{staticClass:"cdh-logo-cursive"},[_vm._v("for ")]),_vm._v("Digital\n  "),_c('br'),_vm._v("Humanities\n")])
}]

export { render, staticRenderFns }